<template>
<div class="chapter">
<div class="inner_page">
<h1 class="cn"><a href="#/SeducedByARogu_toc#chap-2"><em>Chapter 2</em></a></h1>
<p class="cotx"><span class="dropcap">M</span>airi was dismayed to find as she entered the hall that Robert Maxwell had chosen that moment to beard her father there. She
         managed to keep her composure only until the porter, Jeb Logan, identified him as brother to the “vexatious sheriff.”
      </p>
<p>Meeting Maxwell’s gaze, she knew she had let her amusement show.</p>
<p>The devilish man was frowning. So either he disapproved of her reaction or there was another, unknown cause. However, he continued
         to look at her almost as if he were challenging her. What the challenge might be, she did not know. But that look was as disturbing
         as others had been when they first met.
      </p>
<p>Only when he walked right into Jeb Logan, still standing at the foot of the dais with his back to him, did a chuckle escape
         her.
      </p>
<p>It was just as well that Jeb <em>had</em> stopped there, she decided, or Maxwell might have tripped over the raised dais and fallen flat on his face.
      </p>
<p>His frown deepened as he collected himself, so perhaps he had heard her chuckle or seen her smile. This time, his frown sent
         a shiver up her spine. He was clearly a man one would be wise not to challenge.
      </p>
<p>Since she had come only to ask her father if he had duties for her to attend, she had no good reason to stay when he had a
         visitor. Normally submissive to her parents and quick to anticipate their wishes, she hesitated despite her certainty that
         Dunwythie would deem her presence unnecessary.
      </p>
<p class="img"><img alt="art" src="images/Art_orn.jpg"/></p>
<p class="spb">Rob saw no sign that the lass meant to leave.</p>
<p>Inwardly cursing his clumsiness but wanting to get to the purpose of his visit, he used the few brief moments before Dunwythie
         acknowledged the porter’s introduction to size up his host.
      </p>
<p>His lordship looked to be about fifty. His once-dark hair had nearly all grayed, doubtless the natural result of raising two
         such comely, still unwed daughters.
      </p>
<p>His clothing looked expensive but unfashionable, for he apparently favored the nobleman’s black robes of earlier days. He
         had dignity, though, and he clearly did not mean to let Rob intimidate him.
      </p>
<p>In a voice that carried easily throughout the great hall, Dunwythie said, “My forebears were stewards of Annandale. Did ye
         know that?”
      </p>
<p>“Aye, my lord. But they are gone and times have changed.”</p>
<p>“They havena changed so much,” Dunwythie said. “We Annandale men still mind our estates well on our own, and look after our
         own people, until we pass into God’s keeping. Likewise do we still pay our Crown taxes through our steward. Ye’re wasting
         your time, lad. Your sheriff is powerless here.”
      </p>
<p>“A sheriff’s power to collect taxes extends throughout his shire, my lord. And whatever else Annandale may be, it is still
         part of Dumfriesshire.”
      </p>
<p>“Faugh,” Dunwythie retorted. “We do as we have always done. Your brother just wants to extend his power to places that have
         never before acknowledged it.”
      </p>
<p>Honesty forbidding that he deny that statement outright, Rob let his gaze drift to the lass again as he tried to think of
         a more persuasive argument.
      </p>
<p>She had not moved but stood listening to them, doubtless hoping his lordship would remain blind to her presence. She must
         have changed her dress, Rob mused. He was sure she had worn something blue beneath her furlined cloak that morning. Now she
         wore a form-clinging pale green kirtle.
      </p>
<p>The snowy, ruffled edging of her shift peeked above its low-cut neckline, delightfully framing her pillowing, creamy white
         breasts.
      </p>
<p>“Well, have ye nowt more to say?” his lordship demanded, abruptly ending Rob’s brief reverie. “Because, if so, I have—”</p>
<p>“Prithee, my lord,” said a softly plump, beautiful woman who bustled in through the doorway the lass had used earlier. “Have
         you seen—Oh, forgive me!” she exclaimed when she saw Rob. “No one told me my lord husband had a guest.”
      </p>
<p>Lady Dunwythie—for so Rob supposed she was—looked but ten or fifteen years older than his lordship’s daughter. A youthful
         pink and white chaplet concealed her hair, and ruthless plucking had produced a fashionably high, bare forehead. She wore
         a loose, rose-colored surcoat with two vertical slits known as fitchets that allowed her to reach keys or other trinkets that
         he could hear clinking beneath it.
      </p>
<p>“Mairi,” she said to the lass, “why do you stand here like a post?”</p>
<p>“One did not like to interrupt, madam,” she said, sweeping her a curtsy.</p>
<p>“This gentleman is Maxwell of Trailinghail,” Dunwythie said to his wife. “He is also brother to the Sheriff of Dumfries, who
         has apparently forgotten that I act as steward in Annandale, as mine ancestors did, and collect the taxes here.”
      </p>
<p>“ ’Tis a great privilege to meet you, madam,” Rob said, making his bow. Then, turning back to his lordship, he said bluntly,
         “You would do well, my lord, to hand over to me any gelt you have collected from the others, to take to the sheriff. Mayhap
         you do not realize it, but he can seize the estates of any landowner who fails to submit to his authority. I warn you, he
         will wield that power if he must.”
      </p>
<p>Dunwythie raised his eyebrows. “Alexander Maxwell had better examine his conscience well before he tries wielding such power
         outside Nithsdale.” His voice hardened as he added, “As to your warning, I’ll tell ye flat that anyone coming here with such
         grievous intent will put himself in mortal peril. Now, if ye want to take supper with us, ye’re welcome. If not…” He made
         a gentle, dismissive gesture.
      </p>
<p>“I will take my leave,” Rob said through gritted teeth. He was frustrated and angry, but he could see nothing to gain by further
         discussion. Even so, he kept his dignity with greater ease than he might have expected.
      </p>
<p>He had learned that her name was Mairi, and it suited her.</p>
<p>Bowing to Lady Dunwythie, he said, “‘Tis an honor to have met your ladyship. And you, my lady,” he added, looking into the
         lass’s calm gray eyes again.
      </p>
<p>She gazed steadily back, whereupon Lady Dunwythie said curtly, “You had no business to come into this hall without your sister
         or another female to bear you company, Mairi. I wonder that your father did not take you to task for it.”
      </p>
<p>Flushing deeply, the lass looked away.</p>
<p>Feeling his temper stir again, Rob called himself to order and abruptly took his leave.</p>
<p class="img"><img alt="art" src="images/Art_orn.jpg"/></p>
<p class="spb">Watching their guest depart, aware that he was angry, Mairi felt an inexplicable sense of loss.</p>
<p>Something about Robert Maxwell let her feel his frustration, even understand it. She was sure that he acted at the sheriff’s
         behest, because the sheriff had been trying for a year to persuade the lords of Annandale to pay their taxes through him.
      </p>
<p>Having spent her own life trying to please those in authority over her, if only to keep the peace, Mairi thought she understood
         why Robert Maxwell was irritated.
      </p>
<p>Just then, Phaeline said, “In faith, my lord, why would the Sheriff of Dumfries even care who collects the Crown taxes? A
         most tiresome task I am sure! One would expect him to be glad that someone else saves him the trouble.”
      </p>
<p>“Bless ye, my love, he cares because collecting them would not only increase <em>his</em> power over Annandale but also that of Clan Maxwell. It would also allow him to demand fees from us <em>and</em> from his grace, the King, for that service. Sithee, he would thereby considerably increase the contents of his own purse.”
      </p>
<p>“Do you not also collect a fee?”</p>
<p>“Aye, sure, I receive a bit from each to defray my cost in conveying the gelt to Stirling each year. But I’d have nowt but
         ill will to gain by increasing such fees at a whim, as the sheriff could. I must depend on those others to support me in times
         of trouble, as I support them. Sithee, if we had to wait for a Maxwell to protect us, we’d wait a gey long time. But never
         mind all that now. How are ye feeling today?”
      </p>
<p>Hastily excusing herself before her stepmother could launch into one of her interminable, much-too-detailed descriptions of
         exactly how she felt, Mairi went up to her own bedchamber.
      </p>
<p>Dunwythie’s explanation of the sheriff’s likely motives had discomfited her, if only because it had reminded her yet again
         of her tenuous position in her family.
      </p>
<p>Although her father had railed against the sheriff many times over the past year, he had not explained the man’s motives so
         clearly before. So the explanation itself had also made it clear that she still had much to learn.
      </p>
<p>Eldest sons learned all about such things from childhood, she was sure, because everyone knew they would inherit their fathers’
         lands, titles, and responsibilities. But, because a man could sire a son at any age, particularly if—like Phaeline—his wife
         was years younger than he was, surely most men without sons kept their hopes of producing one right to the brinks of their
         graves if not until they tumbled into them.
      </p>
<p>Dunwythie, encouraged by his lady wife, was just such a man.</p>
<p>Most of them also delayed teaching their daughters about their estates, just as Dunwythie had done. No need to teach a daughter
         if one was going to have a son!
      </p>
<p>The problem was, of course, that if one did <em>not</em> have a son, the daughter inherited without knowing much about her inheritance.
      </p>
<p>Mairi was in just such a position. She would inherit her father’s estates as a baroness in her own right if she survived him
         and he had no son. But if Phaeline gave him one, Mairi would have only an elder daughter’s portion to offer a husband. Consequently,
         at the ripe age of nineteen, she was still unwed.
      </p>
<p>Fiona had been right to say that Mairi needed an eligible suitor. But a man wanted to know what a woman would bring to a marriage
         <em>before</em> he pursued her.
      </p>
<p>Quietly opening the door to the bedchamber she shared with her half-sister, Mairi found Fiona reclining with her stitchery
         against a pile of cushions in the window embrasure. Not that she was stitching. Cloth, needle, and thread rested in her lap
         while she stared idly at the ceiling.
      </p>
<p>Shutting the door with a snap, Mairi chuckled when Fiona bolted upright.</p>
<p>“Fortunately, it is only I, dearling, not your mother.”</p>
<p>“I did not hear you until you shut the door,” Fiona said. “That latch makes almost no noise at all now.”</p>
<p>“Shall I order someone to make it squeak again? An efficient gillie must have oiled it in the foolish belief that he’d be
         doing us a favor.”
      </p>
<p>“Mock me all you like,” Fiona said with a grimace. “<em>You</em> did not have to listen to a lecture about idleness only a half-hour ago! And just because my lady mother saw that I had stopped
         stitching for a moment to think.”
      </p>
<p>“Prithee, what grave matter occupied your thoughts so completely that you let Phaeline catch you dreaming?” Mairi asked.</p>
<p>Fiona’s blushes answered her question.</p>
<p>“Good sakes, it was that cheeky Jardine!”</p>
<p>“He is not cheeky,” Fiona countered. “He is charming and delightful, not to mention good looking enough to make anyone stare.
         Be honest, Mairi. You were as taken with Robert Maxwell if only you could bring yourself to admit it.”
      </p>
<p>“Don’t be absurd,” Mairi said. “Even if I’d had such a thought, I would have banished it. Neither our father nor your mother
         will countenance such connections for either of us. You must know that, Fiona. ’Tis rash to think otherwise. They are not
         suitable for us!”
      </p>
<p>“Aye, so you told me, but I care even less for your opinion now than I did then!” Hunching a shoulder, Fiona shoved her needlework
         off her lap.
      </p>
<p>“You are being childish,” Mairi said. “What if I told you that, just a short time ago, Robert Maxwell was in the great hall
         with our father?”
      </p>
<p>Fiona’s frown vanished and she jumped to her feet. “Was <em>he</em> with him?”
      </p>
<p>“No <em>he</em> was not. Even a Maxwell could not be foolish enough to bring that insolent lad with him on such an errand.”
      </p>
<p>“Why not?”</p>
<p>“Because Father would dislike such insolence and Maxwell is now trying to persuade him to hand over <em>any</em> taxes he collects to the sheriff.”
      </p>
<p>Fiona said thoughtfully, “The Maxwells are powerful, are they not? Mayhap Father should be more conciliating.”</p>
<p>“If you paid more heed, Fee, you would know the very point in refusing to do so is that the more their power increases, the
         more they can affect what becomes of <em>us</em>. If we simply submit to each decree, they will just demand more. Cousin Jenny says it is important to understand all things
         that affect one’s life or property. And surely, you realize by now that she knows more than we do about such things.”
      </p>
<p>“Jenny and you need to know those things, aye. But I do not,” Fiona said. “I’ll be glad to see her when we visit Thornhill
         for Easter, and we can talk about anything you like with her then. But she is already a baroness in her own right, and you
         may become one. I am unlikely <em>ever</em> to do so.”
      </p>
<p>Mairi sighed. “One cannot know the future, Fee. I do wish, though, that our father had seen fit to teach us as much as Jenny’s
         father taught her. If Father should die without a son, I doubt I shall know enough to run everything properly.”
      </p>
<p>“Aye, your lot is a hard one,” Fiona agreed with a grimace.</p>
<p>Mairi looked narrowly at her, suspecting sarcasm.</p>
<p>Catching the look, Fiona said hastily, “I mean that, Mairi, for it <em>is</em> hard. It would be gey easier for all of us if my mother and our father would stop trying to make a son and Father would name
         you his heir. Think about <em>me</em>!”
      </p>
<p>Mairi did not try to conceal her amusement at the rider. “You think that your lot is even harder?”</p>
<p>“Aye, sure, it is! Sithee, you will inherit Father’s title and all his estates. I shall inherit only Mam’s tocher.”</p>
<p>“Only our beautiful Annan House, its lands, and a generous sum to support it,” Mairi said. “Poor Fee! But whatever happens,
         no good can come from encouraging the likes of William Jardine.”
      </p>
<p>“But we never meet any <em>eligible</em> young men, and I <em>like</em> Will Jardine!”
      </p>
<p>Gathering patience, Mairi said, “Dearest one, we talk of a man whose entire family is untrustworthy. The Jardines have a long
         history of collaborating with the English against us. Now they simply accept English occupation of Lochmaben, the ancient
         seat of the Bruces and the most impregnable castle in Annandale.”
      </p>
<p>“So do the Maxwells!”</p>
<p>“Aye, they do. But recall how Will Jardine treated you. Could you truly care for a man so insensitive to your rank and to
         the respect due to a noblewoman… to any woman? Faith, he treated you with extraordinary incivility!”
      </p>
<p>“I don’t <em>care</em> about civility. I thought he was amusing and charming. And he is quite the handsomest man I have ever seen.”
      </p>
<p>Mairi might have debated that point, because she thought Robert Maxwell was better looking. However, comparing the two men
         in any way being clearly unwise then, she said only, “Mayhap so, but I warrant William will look just like his father one
         day. Men frequently do, you know. Have you ever seen Old Jardine?”
      </p>
<p>Fiona frowned. “I never saw any Jardine before today.”</p>
<p>“He came here once to raise some sort of grievance when I was about twelve. I remember that he had a bulbous red nose, tiny
         eyes, and he was fat. He was angry, though, which may account for the redness but not for his piggy eyes or vast girth.”
      </p>
<p>“Mercy, I would not allow any husband of mine to grow fat,” Fiona declared. “Why was Old Jardine angry?”</p>
<p>“I don’t know,” Mairi said. “I could see that he was as soon as they announced him, but Father sent me away. Whatever it was,
         I expect Jardine got short shrift.”
      </p>
<p>With a sudden mischievous glint, Fiona said, “Think you that Robert Maxwell will take supper with us this evening?”</p>
<p>Mairi rolled her eyes. “He has already departed, Fee, likely for Applegarth. Sithee, it has begun to rain, and he would never
         make Dumfries before dark.”
      </p>
<p class="img"><img alt="art" src="images/Art_orn.jpg"/></p>
<p class="spb">Inside Spedlins Tower, the Jardine stronghold at Applegarth, Rob changed to warm, dry clothing and found his younger host
         awaiting him in the great hall.
      </p>
<p>“Come in and take a whisky to warm you,” Will said. As he poured from jug to mug, he shot Rob a look from under his eyebrows.
         “Did Dunwythie submit?”
      </p>
<p>“Nay, but I did not expect it,” Rob said, gratefully accepting the whisky and taking a sip as he moved to stand by the fire.
         The ride back in increasingly heavy rain had chilled him to the bone. But the fire and the whisky warmed him.
      </p>
<p>Will’s father, known generally as Old Jardine, entered soon afterward. As he shook Rob’s hand, the old man said, “I’d wager
         ye got nowt from Dunwythie.”
      </p>
<p>“You’d be right, sir,” Rob replied evenly.</p>
<p>His host grinned. “Ye’ll get nowt from me, either, for all that we be friends.”</p>
<p>“I know that,” Rob said. He knew, too, that although the Jardines were currently Maxwell allies, they were apt to change shirts
         with any passing breeze. Regarding taxes, at least, Old Jardine was at one with the men of Annandale.
      </p>
<p>Pacifically, the old man said, “I’ve nae particular quarrel wi’ Dunwythie at present. Sithee, he’s a peaceable chap most days.”</p>
<p>“Peace is good, sir,” Rob said. “We would be wise to encourage more of it. The last thing we want is for war to erupt hereabouts.”</p>
<p>“’Tis true,” Jardine said. “With Dunwythie’s connections to the Lord o’ Galloway and Douglas o’ Thornhill, anyone who stirs
         trouble in Annandale risks bringing the whole lot o’ them down on us. I’ve nae wish to stir up any Douglas.”
      </p>
<p>“No one has such a wish,” Rob said. Trailinghail lay in Galloway, and he knew that men had good reason for calling its lord
         “Archie the Grim.”
      </p>
<p>“Aye, well, the Jardines have strong connections, too,” Will said.</p>
<p>“We Maxwells amongst them,” Rob said amiably. “But you cannot want to quarrel with the Dunwythies. Sakes, you’d make friends
         with at least one of them.”
      </p>
<p>“Which o’ them would that be, lad?” Old Jardine said, shooting his son a narrow-eyed look.</p>
<p>Will shrugged. “Just a wench, Da. Nae one of import, although I’ll admit she’d be a tasty morsel. Ye’ll be leaving us come
         morning, Rob, won’t ye?”
      </p>
<p>Rob agreed that he would and took the opportunity to change the subject to one less likely to stir debate. He was glad to
         bid them both goodnight right after supper, although he was not looking forward to returning to Dumfries.
      </p>
<p>He had gathered the information Alex wanted about Annandale landholders. But he knew the sheriff had hoped—even expected—that
         he would somehow manage to persuade Dunwythie and the others to submit to his authority.
      </p>
<p>Rob still doubted that anything short of an army could accomplish that goal. The Maxwells could certainly raise one if necessary.
         But so could others, including Archie the Grim. And Archie would surely side with his kinsman.
      </p>
<p>Heaven alone knew what the result of such a clash as that might be.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SeducedByARogu_chap-2.vue?8dcd7772